import type { Ctx } from "../../types";
import { Query } from "gg-wf-scripts";
import type { Database } from "@shared/database.types";
import { formatTimestamp } from "../../lib";
import { roleLabels } from "./_helpers";

type Row = {
  id: string;
  full_name: string | null;
  email: string | null;
  created_at: string;
  role: Database["public"]["Enums"]["user_role"] | null;
  invite_sent_at: string;
  invite_expires_at: string;
  invite_expired: boolean;
};

// Invited-but-unconfirmed users from GET /api/stats/pending-invites, newest
// first. Superuser only.
export const pending_invites: Query<Ctx> = async ({ sb }, _params) => {
  const { data, error } = await sb.functions.invoke<Row[] | null>(
    "api/stats/pending-invites",
    { method: "GET" }
  );
  if (error) console.error("pending_invites:", error);
  const rows = data ?? [];

  return rows.map((row) => ({
    ...row,
    f_role: row.role ? roleLabels[row.role] ?? row.role : null,
    f_created_at: formatTimestamp(row.created_at),
    f_invite_sent_at: formatTimestamp(row.invite_sent_at),
    f_invite_expires_at: formatTimestamp(row.invite_expires_at),
  }));
};
